export enum AccordionTypes {
  AccordionInstallmentGroupItem = "accordioninstallmentgroupitem",
  AccordionBulletGroupItem = "accordionbulletgroupitem",
  AccordionPlainTextItem = "accordionplaintextitem",
  AccordionDescriptionPlainTextItem = "accordiondescriptionplaintextitem",
  AccordionCarouselOption = "carouseloption",
  AccordionImageGroupItem = "imagegroupcomponent",
  LogoListGroupComponent = "logolistgroupomponent",
  AccordionBulletItem = "accordionbulletitem",
  AccordionImageItem = "imageitem",
  AccordionInstallmentItem = "accordioninstallmentitem",
  AccordionItem = "accordionitem",
  AccordionLogoListItem = "logolistitem",
  AccordionOption = "accordionoption",
}
